import { apiClient } from '@shared/services/api';
import { fetchFileBlob } from '@shared/utils/fileBlob';

export const prefix = '/apps/praiseboard';
export async function get(path, params) { return (await apiClient.get(prefix + path, { params })).data; }
export async function post(path, payload, options) { return (await apiClient.post(prefix + path, payload || {}, options)).data; }
export async function patch(path, payload) { return (await apiClient.patch(prefix + path, payload || {})).data; }
export async function remove(path) { return (await apiClient.delete(prefix + path)).data; }
// The shared client defaults to JSON, which would turn a FormData body into an empty object.
export async function uploadForm(path, form) {
  return (await apiClient.post(prefix + path, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
}

// A short sentence for the user, never raw JSON.
export function message(error, fallback) {
  const response = error && error.response;
  const detail = response && response.data && response.data.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail.message === 'string') return detail.message;
  if (Array.isArray(detail)) {
    return detail.map(item => item.msg ? String(item.msg).replace(/^Value error, /, '')
      : 'Please check ' + String((item.loc || []).slice(-1)[0] || 'the form').replace(/_/g, ' ') + '.').join(' ');
  }
  if (response && response.status === 404) return fallback || 'That item no longer exists.';
  if (response && response.status === 429) return 'Too many requests from this connection. Please try again in a few minutes.';
  if (response && response.status >= 500) return 'Something went wrong on our side. Please try again in a moment.';
  return fallback || 'We could not reach the server. Check your connection and try again.';
}

export function code(error) {
  const detail = error && error.response && error.response.data && error.response.data.detail;
  return detail && typeof detail === 'object' ? detail.code || '' : '';
}

// The 402 a plan limit raises: {code: 'plan_limit', limit, message, upgrade_to}. Null otherwise.
export function planLimit(error) {
  const response = error && error.response;
  const detail = response && response.status === 402 && response.data ? response.data.detail : null;
  return detail && typeof detail === 'object' && detail.code === 'plan_limit' ? detail : null;
}

// Private files (photos under review, CSV exports) need the session, so they are fetched with it.
export async function blob(path, params) {
  return fetchFileBlob(apiClient, prefix + path, params ? { params } : undefined);
}

export async function download(path, filename, params) {
  const data = await blob(path, params);
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 5000);
}

const images = new Map();
// An object URL for a private image (cached per page load).
export function privateImage(id) {
  if (!id) return Promise.resolve('');
  if (!images.has(id)) {
    const request = blob('/images/' + id + '/file').then(data => URL.createObjectURL(data))
      .catch(error => { images.delete(id); throw error; });
    images.set(id, request);
  }
  return images.get(id);
}
